var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('column-list',{attrs:{"title":'中古車で人気のモデルやメーカー・MT車に関するコラム',"linkList":_vm.linkList}}),_c('column-footer',{attrs:{"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }